<script setup>
/* Props */
const props = defineProps({
  formattedPrice: {
    type: String,
    default: '',
  },
  showPriceLoader: {
    type: Boolean,
    default: false,
  },
  showPriceData: {
    type: Boolean,
    default: false,
  },
  displayedSalePrice: {
    type: String,
    default: '',
  },
  displayedSavings: {
    type: String,
    default: '',
  },
});

const priceDataTestId = {
  host: 'g__main-price',
  originalPrice: {
    wrapper: 'g__main-price__original-price',
    fromText: 'g__main-price__original-price__from-text',
    value: 'g__main-price__original-price__value',
    savingsText: 'g__main-price__original-price__saving-text',
  },
  discountedPrice: {
    wrapper: 'g__main-price__discounted-price',
  },
  detailsText: 'g__main-price__details-text',
  andUpText: 'g__main-price__and-up-text',
};
</script>

<template>
  <div
    v-if="props.showPriceLoader"
    class="product__info__price__loader-wrapper"
    data-testid="product-info-price-loader"
  >
    <g-loader type="dark" />
  </div>
  <div v-else>
    <g-price
      v-if="props.showPriceData"
      class="product__info__price"
      variant="stacked"
      :dataTestId.prop="priceDataTestId"
      :original-price="props.formattedPrice"
      :discounted-price="props.displayedSalePrice"
      :savings-text="props.displayedSavings"
    />
  </div>
</template>

<style lang="scss" scoped>
.product__info__price {
  margin-bottom: $spacing-xs;
  margin-top: $spacing-md;

  &__loader-wrapper {
    width: 4.6875rem; // 75px
    margin-bottom: $spacing-xs;
  }

  :deep(.g__price__original-price) {
    font-size: 1.5rem; // 24px
  }

  :deep(.g__price--strike) {
    font-size: $font-size-small;

    .savings-text {
      font-size: $font-size-small;

      .price-save-text {
        margin-right: $spacing-xs;
      }
    }
  }
}
</style>
